import React, { useState, useEffect } from "react";
// import React from "react";
import {
    Table, Input, Space,
    Drawer, Tooltip, Switch, Modal, Tag
} from 'antd';
import Button from "antd-button-color";
import Highlighter from 'react-highlight-words';
import { FileExcelOutlined, SearchOutlined, PlusOutlined, DeleteOutlined, ToolOutlined, UndoOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { getStaffList, staffStatus, reportUserExcel } from "./service";
import Addform from "./addform"
import Editform from "./editform"
import _ from "lodash";

const { confirm } = Modal;
function success(e) {
    // console.log('www', e)
    let secondsToGo = 15;
    const onOkModal = () => {
        window.location.reload();
    }
    const modal = Modal.success({
        title: 'จัดการข้อมูลพนักงาน เรียบร้อยแล้ว!',
        okText: 'OK',
        onOk: () => {
            onOkModal()
        },
    });
    const timer = setInterval(() => {
        secondsToGo -= 1;
    }, 1000);
    setTimeout(() => {
        clearInterval(timer);
        modal.destroy();
        window.location.reload();
    }, secondsToGo * 1000);
}

function showConfirm(e) {
    // console.log('e', e)
    if (e.e == true) {
        // console.log('เปิด');
        confirm({
            title: 'ต้องการเปิดการใช้งานพนักงานท่านนี้ ใช่หรือไม่?',
            icon: <ExclamationCircleOutlined />,
            content: e.record.firstName_th + ' ' + e.record.lastName_th,
            okText: 'ใช่',
            // okType: 'danger',
            cancelText: 'ไม่ใช่',
            onOk() {
                // console.log('OK');
                let data = {
                    "status": 'active',
                    "empCd": e.record.empCd
                }
                staffStatus(data).then(res => {
                    // console.log("res===", res)
                    if (res && res.status === 200) {
                        success('no')
                    }
                })
            },
            onCancel() {
                // console.log('Cancel');
            },
        });
    } else {
        // console.log('ปิด');
        confirm({
            title: 'ต้องการปิดการใช้งานพนักงานท่านนี้ ใช่หรือไม่?',
            icon: <ExclamationCircleOutlined />,
            content: e.record.firstName_th + ' ' + e.record.lastName_th,
            okText: 'ใช่',
            // okType: 'danger',
            cancelText: 'ไม่ใช่',
            onOk() {
                // console.log('OK');
                let data = {
                    "status": 'not active',
                    "empCd": e.record.empCd
                }
                staffStatus(data).then(res => {
                    // console.log("res===", res)
                    if (res && res.status === 200) {
                        success('off')
                        // form.resetFields();
                    }
                })
            },
            onCancel() {
                // console.log('Cancel');
            },
        });
    }
}

class Staff extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            searchText: '',
            searchedColumn: '',
            sortedInfo: null,
            data: null,
            visibleAdd: false,
            visibleEdit: false,
            staffDetail: null,
            current: 1,
            pageSize: 10,
        };
    }

    componentDidMount() {
        // console.log('componentDidMount', this.props)
        this.getData();
    }

    getData = () => {
        getStaffList().then(res => {
            // console.log("res===", res)
            if (res && res.status === 200) {
                this.setState({
                    data: res.data.info
                })
            }
        })
    }

    getColumnSearchProps = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={node => {
                        this.searchInput = node;
                    }}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Search
                    </Button>
                    <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                        Reset
                    </Button>
                    <Button
                        type="link"
                        size="small"
                        onClick={() => {
                            confirm({ closeDropdown: false });
                            this.setState({
                                searchText: selectedKeys[0],
                                searchedColumn: dataIndex,
                            });
                        }}
                    >
                        Filter
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
        onFilter: (value, record) =>
            record[dataIndex]
                ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
                : '',
        onFilterDropdownVisibleChange: visible => {
            if (visible) {
                setTimeout(() => this.searchInput.select(), 100);
            }
        },
        // render: text =>
        //     this.state.searchedColumn === dataIndex ? (
        //         <Highlighter
        //             highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        //             searchWords={[this.state.searchText]}
        //             autoEscape
        //             textToHighlight={text ? text.toString() : ''}
        //         />
        //     ) : (
        //         text
        //     ),
    });

    getColumnSearchProps2 = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={node => {
                        this.searchInput = node;
                    }}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Search
                    </Button>
                    <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                        Reset
                    </Button>
                    <Button
                        type="link"
                        size="small"
                        onClick={() => {
                            confirm({ closeDropdown: false });
                            this.setState({
                                searchText: selectedKeys[0],
                                searchedColumn: dataIndex,
                            });
                        }}
                    >
                        Filter
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
        onFilter: (value, record) =>
            record[dataIndex]
                ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
                : '',
        onFilterDropdownVisibleChange: visible => {
            if (visible) {
                setTimeout(() => this.searchInput.select(), 100);
            }
        },
    });

    handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        this.setState({
            searchText: selectedKeys[0],
            searchedColumn: dataIndex,
        });
    };

    handleReset = clearFilters => {
        clearFilters();
        this.setState({ searchText: '' });
    };

    handleChange = (pagination, filters, sorter) => {
        // console.log('Various parameters', pagination, filters, sorter);
        this.setState({
            filteredInfo: filters,
            sortedInfo: sorter,
            current: pagination.current,
            pageSize: pagination.pageSize
        });
    };

    clearFilters = () => {
        this.setState({ filteredInfo: null });
    };

    clearAll = () => {
        this.setState({
            filteredInfo: null,
            sortedInfo: null,
        });
    };

    setAgeSort = () => {
        this.setState({
            sortedInfo: {
                order: 'descend',
                columnKey: 'age',
            },
        });
    };

    showDrawerAdd = () => {
        this.setState({
            visibleAdd: true,
        });
    };

    showDrawerEdit = (e) => {
        // console.log("showDrawerEdit", e.record)

        this.setState({
            visibleEdit: true,
            staffDetail: e.record
        });
    };

    onCloseAdd = () => {
        this.setState({
            visibleAdd: false,
        });
    };

    onCloseEdit = () => {
        this.setState({
            visibleEdit: false,
            // staffDetail: null
        });
    };

    dd = () => {
        // console.log("this.state", this.state)
    }
    renderEditForm = (level) => {
        // console.log("render", this.state.staffDetail)
        return (
            <Drawer
                title="แก้ไขข้อมูลพนักงานขาย"
                width={720}
                onClose={this.onCloseEdit}
                visible={this.state.visibleEdit}
                bodyStyle={{ paddingBottom: 1 }}

            >
                <Editform
                    staffDetail={this.state.staffDetail}
                    userLevel={level}
                />
            </Drawer>
        )
    }

    onChangeSwitch = (checked) => {
        showConfirm(checked)
    }

    exportExcel = () => {
        reportUserExcel()
    }
    render() {
        var current = this.state.current
        var pageSize = this.state.pageSize
        var columns = []
        let level = this.props.userdata.userdata.level
        if (level == 1 || level == 99) {
            // console.log('Admin')
            columns = columns.concat([
                {
                    title: 'ลำดับ',
                    align: 'center',
                    width: '5%',
                    key: 'no',
                    render: (text, record, index) => {
                        return (((current - 1) * pageSize) + index + 1)
                    },
                },
                {
                    title: 'รหัสเขต',
                    // dataIndex: 'territory_tID',
                    // key: 'territory_tID',
                    width: '8%',
                    render: (tags, record) => (
                        <>
                            {record.territory_tID.map(tag => {
                                let chk_tag = tag.substring(0, 3)
                                let color = 'green';
                                if (chk_tag == 111) {
                                    color = 'red'
                                } if (chk_tag == 112) {
                                    color = 'magenta'
                                } if (chk_tag == 113) {
                                    color = 'orange'
                                } if (chk_tag == 114) {
                                    color = 'gold'
                                } if (chk_tag == 121) {
                                    color = 'green'
                                } if (chk_tag == 122) {
                                    color = 'cyan'
                                } if (chk_tag == 123) {
                                    color = 'blue'
                                } if (chk_tag == 124) {
                                    color = 'geekblue'
                                } if (chk_tag == 211) {
                                    color = 'lime'
                                } if (chk_tag == 311) {
                                    color = 'purple'
                                }
                                return (
                                    <Tag color={color} key={tag}>
                                        {tag.toUpperCase()}
                                    </Tag>
                                );
                            })}
                        </>
                    ),
                    ...this.getColumnSearchProps('territory_tID'),
                },
                {
                    title: 'ชื่อเขต',
                    dataIndex: 'saleAreaDesc',
                    key: 'saleAreaDesc',
                    width: '11%',
                    render: (tags, record) => (
                        <>
                            {record.territory_desc.map((tag, index) => {
                                let chk_tag = record.territory_tID[index].substring(0, 3)
                                let color = 'green';
                                if (chk_tag == 111) {
                                    color = 'red'
                                } if (chk_tag == 112) {
                                    color = 'magenta'
                                } if (chk_tag == 113) {
                                    color = 'orange'
                                } if (chk_tag == 114) {
                                    color = 'gold'
                                } if (chk_tag == 121) {
                                    color = 'green'
                                } if (chk_tag == 122) {
                                    color = 'cyan'
                                } if (chk_tag == 123) {
                                    color = 'blue'
                                } if (chk_tag == 124) {
                                    color = 'geekblue'
                                } if (chk_tag == 211) {
                                    color = 'lime'
                                } if (chk_tag == 311) {
                                    color = 'purple'
                                }
                                return (
                                    <Tag color={color} key={tag}>
                                        {tag.toUpperCase()}
                                    </Tag>
                                );
                            })
                            }
                        </>
                    ),
                    ...this.getColumnSearchProps('saleAreaDesc'),
                },
                {
                    title: 'รหัสพนักงาน',
                    dataIndex: 'empCd',
                    key: 'empCd',
                    width: '11%',
                    ...this.getColumnSearchProps('empCd'),
                },
                {
                    title: 'ชื่อ - นามสกุล',
                    dataIndex: ['firstName_th', 'lastName_th'],
                    key: 'firstName_th',
                    width: '16%',
                    render: (text, record) => (
                        <Space size="small">
                            {record.firstName_th}{record.lastName_th}
                        </Space>
                    ),
                    // ellipsis: true,
                    ...this.getColumnSearchProps2('firstName_th'),
                },
                {
                    title: 'เบอร์โทรศัพท์',
                    dataIndex: ['phone'],
                    key: 'phone',
                    width: '11%',
                    render: (text, record) => (
                        <Space size="small">
                            {/* {record.phone && record.phone} */}
                            {record.phone}
                        </Space>
                    ),
                    ellipsis: true,
                    ...this.getColumnSearchProps2('phone'),
                },
                {
                    title: 'อีเมล์',
                    dataIndex: ['email'],
                    key: 'email',
                    width: '16%',
                    // render: (text, record) => (
                    //     <Space size="small">
                    //         {record.email}
                    //     </Space>
                    // ),
                    ellipsis: true,
                    ...this.getColumnSearchProps2('email'),
                },
                {
                    title: 'ชื่อผู้ใช้งาน',
                    key: 'username',
                    dataIndex: 'username',
                    width: '10%',
                    ...this.getColumnSearchProps2('username'),
                },
                {
                    title: 'แก้ไข',
                    key: 'action',
                    width: '5%',
                    align: 'center',
                    fixed: 'right',
                    render: (text, record) => (
                        <Space size="small">
                            <Tooltip title="edit user">
                                <Button with="ghost" type="success" shape="circle" icon={<ToolOutlined />} size="small"
                                    // onClick={this.showDrawerEdit}
                                    onClick={() => {
                                        this.showDrawerEdit({ record })
                                        // console.log("record", record)
                                    }
                                    }
                                />
                            </Tooltip>
                            {/* <Tooltip title="reset password">
                                <Button with="ghost" type="warning" shape="circle" icon={<UndoOutlined />} size="small" />
                            </Tooltip> */}

                        </Space>
                    ),
                },
                {
                    title: 'สถานะ',
                    key: 'status',
                    width: '7%',
                    align: 'center',
                    fixed: 'right',
                    render: (text, record) => (
                        <Tooltip title={record.isActive === '1' ? "active" : "not active"}>
                            <Switch
                                disabled={level == 99 ? false : true}
                                // disabled={true}
                                defaultChecked={record.isActive === '1' ? true : false}
                                onChange={(e) => {
                                    this.onChangeSwitch({ e, record })
                                    // console.log("record", record)
                                }
                                }
                                checkedChildren="เปิด"
                                unCheckedChildren="ปิด"
                            />
                        </Tooltip>
                    ),
                    ellipsis: true,
                    // ...this.getColumnSearchProps2('isActive'),
                },
            ])
        } else {
            // console.log('NoAdmin')
            columns = columns.concat([
                {
                    title: 'ลำดับ',
                    width: '5%',
                    key: 'no',
                    align: 'center',
                    render: (text, record, index) => {
                        return (((current - 1) * pageSize) + index + 1)
                    },
                },
                {
                    title: 'รหัสเขต',
                    // dataIndex: 'territory_tID',
                    // key: 'territory_tIDd',
                    width: '8%',
                    render: (tags, record) => (
                        <>
                            {record.territory_tID.map(tag => {
                                let chk_tag = tag.substring(0, 3)
                                let color = 'green';
                                if (chk_tag == 111) {
                                    color = 'red'
                                } if (chk_tag == 112) {
                                    color = 'magenta'
                                } if (chk_tag == 113) {
                                    color = 'orange'
                                } if (chk_tag == 114) {
                                    color = 'gold'
                                } if (chk_tag == 121) {
                                    color = 'green'
                                } if (chk_tag == 122) {
                                    color = 'cyan'
                                } if (chk_tag == 123) {
                                    color = 'blue'
                                } if (chk_tag == 124) {
                                    color = 'geekblue'
                                } if (chk_tag == 211) {
                                    color = 'lime'
                                } if (chk_tag == 311) {
                                    color = 'purple'
                                }
                                return (
                                    <Tag color={color} key={tag}>
                                        {tag.toUpperCase()}
                                    </Tag>
                                );
                            })}
                        </>
                    ),
                    ...this.getColumnSearchProps('territory_tID'),
                },
                {
                    title: 'ชื่อเขต',
                    dataIndex: 'saleAreaDesc',
                    key: 'saleAreaDesc',
                    width: '11%',
                    render: (tags, record) => (
                        <>
                            {record.territory_desc.map((tag, index) => {
                                let chk_tag = record.territory_tID[index].substring(0, 3)
                                let color = 'green';
                                if (chk_tag == 111) {
                                    color = 'red'
                                } if (chk_tag == 112) {
                                    color = 'magenta'
                                } if (chk_tag == 113) {
                                    color = 'orange'
                                } if (chk_tag == 114) {
                                    color = 'gold'
                                } if (chk_tag == 121) {
                                    color = 'green'
                                } if (chk_tag == 122) {
                                    color = 'cyan'
                                } if (chk_tag == 123) {
                                    color = 'blue'
                                } if (chk_tag == 124) {
                                    color = 'geekblue'
                                } if (chk_tag == 211) {
                                    color = 'lime'
                                } if (chk_tag == 311) {
                                    color = 'purple'
                                }
                                return (
                                    <Tag color={color} key={tag}>
                                        {tag.toUpperCase()}
                                    </Tag>
                                );
                            })
                            }
                        </>
                    ),
                    ...this.getColumnSearchProps('saleAreaDesc'),
                },
                {
                    title: 'รหัสพนักงาน',
                    dataIndex: 'empCd',
                    key: 'empCd',
                    width: '11%',
                    ...this.getColumnSearchProps('empCd'),
                },
                {
                    title: 'ชื่อ - นามสกุล',
                    dataIndex: ['firstName_th', 'lastName_th'],
                    key: 'firstName_th',
                    width: '16%',
                    render: (text, record) => (
                        <Space size="small">
                            {record.firstName_th}{record.lastName_th}
                        </Space>
                    ),
                    ellipsis: true,
                    ...this.getColumnSearchProps2('firstName_th'),
                },
                {
                    title: 'เบอร์โทรศัพท์',
                    dataIndex: ['phone'],
                    key: 'phone',
                    width: '11%',
                    render: (text, record) => (
                        <Space size="small">
                            {/* {record.phone && record.phone} */}
                            {record.phone}
                        </Space>
                    ),
                    ellipsis: true,
                    ...this.getColumnSearchProps2('phone'),
                },
                {
                    title: 'อีเมล์',
                    dataIndex: ['email'],
                    key: 'email',
                    width: '16%',
                    render: (text, record) => (
                        <Space size="small">
                            {record.email}
                        </Space>
                    ),
                    ellipsis: true,
                    ...this.getColumnSearchProps2('email'),
                },
                {
                    title: 'แก้ไข',
                    key: 'action',
                    width: '5%',
                    align: 'center',
                    fixed: 'right',
                    render: (text, record) => (
                        <Space size="small">
                            <Tooltip title="edit user">
                                <Button with="ghost" type="success" shape="circle" icon={<ToolOutlined />} size="small"
                                    onClick={() => {
                                        this.showDrawerEdit({ record })
                                        // console.log("record", record)
                                    }
                                    }
                                />
                            </Tooltip>
                        </Space>
                    ),
                },
                {
                    title: 'สถานะ',
                    key: 'status',
                    width: '7%',
                    align: 'center',
                    fixed: 'right',
                    render: (text, record) => (
                        <Tooltip title={record.isActive === '1' ? "active" : "not active"}>
                            <Switch
                                // size="small"
                                disabled={true}
                                defaultChecked={record.isActive === '1' ? true : false}
                                onChange={this.onChangeSwitch}
                                checkedChildren="เปิด"
                                unCheckedChildren="ปิด"
                            />
                        </Tooltip>
                    ),
                    ellipsis: true,
                    ...this.getColumnSearchProps2('status'),
                },
            ])
        }
        console.log('this.state.data', this.state.data)
        return (
            <>
                <Space style={{ marginBottom: 16 }}>
                    <h2>จัดการข้อมูลพนักงานขาย</h2>
                </Space>
                {
                    level == 99 &&
                    <Button type="success" icon={<FileExcelOutlined />}
                        style={{ float: 'right' }}
                    // onClick={this.exportExcel}
                    >
                        <a href='https://loxtrade.orb-sams.mobi:8080/api/v1/web/report/salestaff/excel' style={{ padding: '0px 2px 0px 8px', color: 'white' }}>Export</a>
                    </Button >
                }
                {
                    level == 99 &&
                    <Button type="primary" onClick={this.showDrawerAdd}
                        style={{ float: 'right', marginRight: '10px' }}
                    >
                        <PlusOutlined /> Add Sale
                    </Button>
                }
                {/* <Button type="primary" onClick={this.dd} style={{ float: 'right' }}>
                    <PlusOutlined /> dd
                </Button> */}

                <Table
                    className="myTable"
                    rowClassName={(record, index) => index % 2 === 0 ? 'table-row-light' : 'table-row-dark'}
                    columns={columns}
                    dataSource={this.state.data}
                    onChange={this.handleChange}
                    // scroll={{ x: 1500, y: 300 }}
                    scroll={{ x: 1110, y: '100%' }}
                    size="small"
                    rowKey="empCd"
                    bordered
                />
                <Drawer
                    title="เพิ่มพนักงานขาย"
                    width={720}
                    onClose={this.onCloseAdd}
                    visible={this.state.visibleAdd}
                    bodyStyle={{ paddingBottom: 1 }}
                >
                    <Addform />
                </Drawer>
                {/* <Drawer
                    title="แก้ไขข้อมูลพนักงานขาย"
                    width={720}
                    onClose={this.onCloseEdit}
                    visible={this.state.visibleEdit}
                    bodyStyle={{ paddingBottom: 1 }}

                >
                    <Editform
                        staffDetail={this.state.staffDetail}
                        userLevel={level}
                    />
                </Drawer> */}
                {this.state.visibleEdit ? this.renderEditForm(level) : <></>}
            </>
        )
    }
}

export default Staff;
